/* eslint-disable @typescript-eslint/no-explicit-any */
import { OidcService } from '@revenuewell/logic-oidc';
import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { CreatePhoneNotificationRequest } from './types';

export default class NotificationService extends AuthApiService {
  private config: any;

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService());
    this.config = config;
    return this;
  }

  sendPhoneNotification = async (request: CreatePhoneNotificationRequest) => {
    const url = `${this.config.ucNotifications.apiUrl}/notifications`;
    await this.authFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request)
    });
  };
}
